import moment from 'moment';

import Waves from '../../../assets/waves.svg';
import { OpenGroup } from '../../../models/Group';
import { CardAvatar } from '../../styledComponent/CardAvatar.style';
import {
  CardContainer,
  CardHeader,
  CardAvatarWrapper,
  GfName,
  GfTitle,
  CardBody,
  GroupTitle,
  GroupSegment,
  GroupTime,
  GroupLive,
  GroupLiveText,
} from '../../styledComponent/OpenRoom.style';
import { getGuideTagline, isRoomLive } from '../../../utils/openRoom';

interface OpenGroupProps {
  openGroup: Partial<OpenGroup>;
  onClick: () => void;
}

export const OpenRoom = ({ openGroup, onClick }: OpenGroupProps) => {
  const { leaderImg, title, nextSession, leaderName, segments, isGroupFacilitator, tagline } = openGroup;

  const date = moment(nextSession?.isoString);
  const isLive = isRoomLive(nextSession?.ts);
  const gfTitle = getGuideTagline({ isGroupFacilitator, tagline });

  return (
    <CardContainer onClick={onClick}>
      <CardHeader>
        <CardAvatarWrapper>
          <CardAvatar size={64} src={leaderImg} />
        </CardAvatarWrapper>
        <GfName>{leaderName}</GfName>
        <GfTitle>{gfTitle}</GfTitle>
      </CardHeader>
      <CardBody>
        {isLive ? (
          <GroupLive>
            <img src={Waves} alt="waves" />
            <GroupLiveText>Live now</GroupLiveText>
          </GroupLive>
        ) : (
          <GroupTime>{`${date.calendar(null, {
            sameDay: '[TODAY AT] h:mm A',
            nextDay: '[TOMORROW AT] h:mm A',
            nextWeek: `[${date.format('dddd').toUpperCase()}] [AT] h:mm A`,
          })}`}</GroupTime>
        )}
        <GroupTitle>{title}</GroupTitle>
        <GroupSegment>{segments?.[0]}</GroupSegment>
      </CardBody>
    </CardContainer>
  );
};
